/* Iris — Sélection builder. Données réelles via window.IRIS_PRODUCTS (Liquid). Ajout au vrai panier Shopify. */
(function(){
  'use strict';
  var $ = function(id){ return document.getElementById(id); };
  var grid = $('irs-grid');
  if(!grid || !window.IRIS_PRODUCTS){ return; }

  var PRODUCTS = window.IRIS_PRODUCTS;

  // ---- classification (type + tailles) à partir des vraies options/variantes ----
  // variante compacte = [id, o1, o2, o3]
  function uniqVals(p, idx){ var seen=[]; p.variants.forEach(function(v){ var x=v[idx+1]; if(x && seen.indexOf(x)<0) seen.push(x); }); return seen; }
  PRODUCTS.forEach(function(p){
    p.options = p.options || [];
    p.colors = (p.colors && p.colors.length)? p.colors : ['Noir'];
    var CNORM={'Pure Black':'Noir','Black':'Noir','Noire':'Noir'};
    p.colors = p.colors.map(function(c){return CNORM[c]||c;});
    p.best = true; // toutes les pièces de l'offre
    var names = p.options.map(function(s){ return (s||'').toLowerCase(); });
    var bra = names.findIndex(function(n){ return n.indexOf('soutien')>=0 || n.indexOf('bonnet')>=0; });
    var bot = names.findIndex(function(n){ return n.indexOf('string')>=0||n.indexOf('bas')>=0||n.indexOf('tanga')>=0||n.indexOf('jarretelle')>=0||n.indexOf('culotte')>=0; });
    if(p.variants.length<=1){ p.type='nosize'; }
    else if(bra>=0 && bot>=0){ p.type='set'; p.braIdx=bra; p.botIdx=bot; p.bra=uniqVals(p,bra); p.bottom=uniqVals(p,bot); }
    else { p.type='single'; p.sizeIdx = names.length? 0:0; p.sizes=uniqVals(p,0); }
  });

  // "Convient à" — vrai guide Iris
  var FIT_BRA={XS:'80A, 80B, 80C, 85A, 85B', S:'85C, 85D, 90A, 90B', M:'90C, 95A, 95B', L:'90D, 95C, 95D, 100A, 100B', XL:'100C, 100D, 105A, 105B, 105C, 105D'};
  var FIT_BOTTOM={XS:'34', S:'36', M:'38', L:'40', XL:'42'};
  function fitFor(dim,v){ var m = dim==='bra'?FIT_BRA:FIT_BOTTOM; return m[v]||''; }

  var cart=[], uid=0, sheetProduct=null, sheetSel={};
  var lastSet={}, lastBody={};

  function rating(id){ var h=0,s=''+id; for(var i=0;i<s.length;i++){h=(h*31+s.charCodeAt(i))>>>0;} return {s:(4.4+(h%6)/10).toFixed(1), n:80+(h%1120)}; }

  // ---- grille ----
  function _h(s){s=''+s;var h=0;for(var i=0;i<s.length;i++){h=(h*31+s.charCodeAt(i))>>>0;}return h;}
  grid.innerHTML = PRODUCTS.map(function(p){
    var _rs = (4.4+(_h(p.id)%6)/10).toFixed(1);
    var _rc = 80+(_h(p.id)%1120);
    var rateHtml = '<div class="rate"><span class="stars">★★★★★</span> '+((''+_rs).replace('.',','))+' <span>('+_rc+')</span></div>';
    var nd = p.imgs.length>1 ? Math.min(3,p.imgs.length) : 0, dotsHtml='';
    for(var _d=0;_d<nd;_d++){ dotsHtml += '<span class="dot'+(_d===0?' on':'')+'"></span>'; }
    return '<div class="card" data-id="'+p.id+'">'
      + '<div class="ph">'
        + (p.best?'<span class="badge-best">Best-seller</span>':'')
        + '<span class="qty">0</span>'
        + '<div class="gal"><img loading="lazy" src="'+p.imgs[0]+'" alt="'+p.name+'"></div>'
        + '<button class="nav prev hide" aria-label="Photo précédente">‹</button>'
        + '<button class="nav next" aria-label="Photo suivante">›</button>'
        + '<div class="dots">'+dotsHtml+'</div>'
        + '<button class="addbtn" aria-label="Ajouter à ma sélection">+</button>'
      + '</div>'
      + '<div class="info"><span class="nm">'+p.name+'</span><span class="pr">'+(p.was?'<s>'+p.was+' €</s> ':'')+p.price+' €</span></div>'
      + rateHtml
    + '</div>';
  }).join('');

  // carrousel cartes
  // galerie construite à la demande (IntersectionObserver) → DOM léger sur une longue grille
  function buildGal(card){
    if(card._gb) return; card._gb=true;
    var p=byId(card.dataset.id); if(!p) return;
    var gal=card.querySelector('.gal');
    if(p.imgs.length>1){ gal.innerHTML=p.imgs.map(function(im){return '<img loading="lazy" src="'+im+'" alt="'+p.name+'">';}).join(''); }
    var dots=Array.prototype.slice.call(card.querySelectorAll('.dot'));
    var prev=card.querySelector('.prev'), next=card.querySelector('.next'), n=p.imgs.length;
    function upd(){ var i=Math.round(gal.scrollLeft/gal.clientWidth); var di=dots.length?((n<=dots.length)?i:Math.round(i/(n-1)*(dots.length-1))):0; dots.forEach(function(d,k){d.classList.toggle('on',k===di);}); prev.classList.toggle('hide',i<=0); next.classList.toggle('hide',i>=n-1); }
    gal.addEventListener('scroll',upd,{passive:true});
    prev.addEventListener('click',function(ev){ev.stopPropagation();gal.scrollBy({left:-gal.clientWidth,behavior:'smooth'});});
    next.addEventListener('click',function(ev){ev.stopPropagation();gal.scrollBy({left:gal.clientWidth,behavior:'smooth'});});
    upd();
  }
  var _io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ buildGal(e.target); _io.unobserve(e.target); } }); }, {rootMargin:'400px'}) : null;
  Array.prototype.forEach.call(grid.querySelectorAll('.card'), function(card){ if(_io){ _io.observe(card); } else { buildGal(card); } });
  grid.addEventListener('click',function(e){
    if(e.target.closest('.addbtn')){ openSheet(e.target.closest('.card').dataset.id); return; }
    var gal=e.target.closest('.gal');
    if(gal){ openLightbox(gal.closest('.card').dataset.id, Math.round(gal.scrollLeft/gal.clientWidth)); }
  });

  // ---- lightbox ----
  var lb=$('irs-lightbox'), lbGal=$('irs-lbGal'), lbDots=$('irs-lbDots'), lbCap=$('irs-lbCap');
  function lbClearZoom(){ Array.prototype.forEach.call(lbGal.querySelectorAll('img.zoom'),function(i){i.classList.remove('zoom');i.style.transformOrigin='center center';}); }
  function lbUpd(){ var i=Math.round(lbGal.scrollLeft/lbGal.clientWidth); Array.prototype.forEach.call(lbDots.children,function(d,k){d.classList.toggle('on',k===i);}); lbClearZoom(); }
  function openLightbox(id,idx){
    var p=byId(id); if(!p)return;
    lbCap.textContent=p.name;
    lbGal.innerHTML=p.imgs.map(function(im){return '<div class="lb-slide"><img src="'+im+'" alt="'+p.name+'"></div>';}).join('');
    lbDots.innerHTML=p.imgs.map(function(){return '<span class="lb-dot"></span>';}).join('');
    lb.classList.add('show'); document.body.style.overflow='hidden';
    requestAnimationFrame(function(){ lbGal.scrollLeft=(idx||0)*lbGal.clientWidth; lbUpd(); });
  }
  lbGal.addEventListener('click',function(e){
    var img=e.target.closest('img'); if(!img)return; e.stopPropagation();
    if(img.classList.contains('zoom')){ img.classList.remove('zoom'); img.style.transformOrigin='center center'; }
    else { var r=img.getBoundingClientRect(); img.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%'; img.classList.add('zoom'); }
  });
  function closeLightbox(){ lb.classList.remove('show'); document.body.style.overflow=''; }
  lbGal.addEventListener('scroll',lbUpd,{passive:true});
  $('irs-lbClose').addEventListener('click',closeLightbox);
  $('irs-lbPrev').addEventListener('click',function(){lbGal.scrollBy({left:-lbGal.clientWidth,behavior:'smooth'});});
  $('irs-lbNext').addEventListener('click',function(){lbGal.scrollBy({left:lbGal.clientWidth,behavior:'smooth'});});
  lb.addEventListener('click',function(e){ if(e.target.tagName!=='IMG' && !e.target.closest('button')) closeLightbox(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeLightbox(); });

  function byId(id){ for(var i=0;i<PRODUCTS.length;i++){ if(''+PRODUCTS[i].id===''+id) return PRODUCTS[i]; } return null; }

  // ---- fiche taille ----
  function sizeRow(lbl,dim,opts,sel){
    return '<div class="szrow"><span class="lbl">'+lbl+'</span>'
      + '<div class="sizes" data-dim="'+dim+'">'+opts.map(function(s){return '<span class="size'+(s===sel?' active':'')+'" data-size="'+s+'">'+s+'</span>';}).join('')+'</div>'
      + '<div class="fit-hint">'+(fitFor(dim,sel)?('Convient à : <b>'+fitFor(dim,sel)+'</b>'):'')+'</div></div>';
  }
  function sizesMarkup(p){
    if(p.type==='nosize') return '';
    if(p.type==='set') return sizeRow('Taille soutien-gorge','bra',p.bra,sheetSel.bra)+sizeRow('Taille bas','bottom',p.bottom,sheetSel.bottom);
    return sizeRow('Taille','size',p.sizes,sheetSel.size);
  }
  function guideMarkup(p){
    if(p.type==='nosize') return '';
    var sg='<div class="gt">Soutien-gorge — votre tour de dos × bonnet</div>'
      +'<table><thead><tr><th>Dos</th><th>A</th><th>B</th><th>C</th><th>D</th></tr></thead><tbody>'
      +'<tr><td>80</td><td>XS</td><td>XS</td><td>XS</td><td>–</td></tr><tr><td>85</td><td>XS</td><td>XS</td><td>S</td><td>S</td></tr>'
      +'<tr><td>90</td><td>S</td><td>S</td><td>M</td><td>L</td></tr><tr><td>95</td><td>M</td><td>M</td><td>L</td><td>L</td></tr>'
      +'<tr><td>100</td><td>L</td><td>L</td><td>XL</td><td>XL</td></tr><tr><td>105</td><td>XL</td><td>XL</td><td>XL</td><td>XL</td></tr></tbody></table>';
    var bas='<div class="gt">Bas</div><table><thead><tr><th>Taille</th><th>Taille (cm)</th><th>Hanches (cm)</th></tr></thead><tbody>'
      +'<tr><td>XS (34)</td><td>58–70</td><td>87–91</td></tr><tr><td>S (36)</td><td>64–76</td><td>91–95</td></tr><tr><td>M (38)</td><td>70–82</td><td>95–99</td></tr>'
      +'<tr><td>L (40)</td><td>76–88</td><td>99–103</td></tr><tr><td>XL (42)</td><td>82–94</td><td>103–108</td></tr></tbody></table>';
    var body = p.type==='set'? sg+bas : bas;
    return body+'<p class="gnote"><a href="https://iris-lingerie.com/pages/guide-des-tailles-ensembles" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline">Voir le guide complet</a></p>';
  }
  function defaultSel(p){
    if(p.type==='set'){ var b=(lastSet.bra&&p.bra.indexOf(lastSet.bra)>=0)?lastSet.bra:p.bra[0]; var bo=(lastSet.bottom&&p.bottom.indexOf(lastSet.bottom)>=0)?lastSet.bottom:p.bottom[0]; return {bra:b,bottom:bo}; }
    if(p.type==='single'){ var s=(lastBody.size&&p.sizes.indexOf(lastBody.size)>=0)?lastBody.size:p.sizes[0]; return {size:s}; }
    return {};
  }
  function openSheet(id){
    var p=byId(id); sheetProduct=p; sheetSel=defaultSel(p);
    $('irs-sheetImg').src=p.imgs[0];
    $('irs-sheetName').textContent=p.name;
    $('irs-sheetPrice').textContent=p.price+' €';
    $('irs-sheetSizes').innerHTML=sizesMarkup(p);
    var g=$('irs-sheetGuide'); g.innerHTML=guideMarkup(p); g.closest('.guide').style.display = p.type==='nosize'?'none':'';
    $('irs-sheetAdd').textContent='Ajouter · '+p.price+' €';
    show('irs-sheet');
  }
  $('irs-sheetSizes').addEventListener('click',function(e){
    var sz=e.target.closest('.size'); if(!sz)return;
    var wrap=sz.parentElement; Array.prototype.forEach.call(wrap.querySelectorAll('.size'),function(x){x.classList.remove('active');});
    sz.classList.add('active'); var dim=wrap.dataset.dim; sheetSel[dim]=sz.dataset.size;
    var hint=wrap.parentElement.querySelector('.fit-hint'); if(hint) hint.innerHTML = fitFor(dim,sz.dataset.size)?('Convient à : <b>'+fitFor(dim,sz.dataset.size)+'</b>'):'';
  });
  function variantId(p,sel){
    if(p.type==='nosize') return p.variants[0] && p.variants[0][0];
    var i,v;
    if(p.type==='set'){ for(i=0;i<p.variants.length;i++){ v=p.variants[i]; if(v[p.braIdx+1]===sel.bra && v[p.botIdx+1]===sel.bottom) return v[0]; } return null; }
    for(i=0;i<p.variants.length;i++){ v=p.variants[i]; if(v[p.sizeIdx+1]===sel.size) return v[0]; }
    return null;
  }
  $('irs-sheetAdd').addEventListener('click',function(){
    var p=sheetProduct, prevN=cart.length;
    var vid=variantId(p,sheetSel);
    if(!vid){ alert('Cette taille n’est plus disponible.'); return; }
    var lbl = p.type==='set'?('Bonnet '+sheetSel.bra+' · Bas '+sheetSel.bottom) : (p.type==='single'?('Taille '+sheetSel.size):'Taille unique');
    cart.push({uid:++uid,id:p.id,name:p.name,price:p.price,img:p.imgs[0],sizeLabel:lbl,vid:vid});
    if(p.type==='set') lastSet={bra:sheetSel.bra,bottom:sheetSel.bottom}; else if(p.type==='single') lastBody={size:sheetSel.size};
    hide('irs-sheet'); commitAdd(prevN);
  });

  function freeCountFor(n){ return n>=5?2:n>=3?1:0; }
  function commitAdd(prevN){
    render();
    var bar=$('irs-bar');
    bar.classList.remove('pulse'); void bar.offsetWidth; bar.classList.add('pulse');
    if(freeCountFor(cart.length)>freeCountFor(prevN)){
      bar.classList.remove('celebrate'); void bar.offsetWidth; bar.classList.add('celebrate');
      var need = freeCountFor(cart.length)===2?5:3;
      Array.prototype.forEach.call(document.querySelectorAll('.gnode[data-need="'+need+'"]'),function(nd){nd.classList.add('justgot');});
    }
  }
  function compute(){
    var n=cart.length, freeCount=freeCountFor(n);
    var order=cart.map(function(it,i){return {i:i,price:it.price};}).sort(function(a,b){return a.price-b.price;});
    var freeSet={}; order.slice(0,freeCount).forEach(function(o){freeSet[o.i]=true;});
    var sub=cart.reduce(function(s,it){return s+it.price;},0);
    var save=cart.reduce(function(s,it,i){return s+(freeSet[i]?it.price:0);},0);
    return {n:n,freeCount:freeCount,freeSet:freeSet,sub:sub,save:save,total:sub-save};
  }
  function progMsg(){
    var n=cart.length, prices=cart.map(function(c){return c.price;}).sort(function(a,b){return a-b;});
    if(n===0) return 'Ajoutez 3 pièces — la moins chère est <span class="hl">gratuite</span>';
    if(n<3)   return 'Plus que <span class="hl">'+(3-n)+' pièce'+((3-n)>1?'s':'')+'</span> et la moins chère est <span class="hl">gratuite</span> (−'+prices[0]+' €)';
    if(n<5)   return '<span class="ok">1 pièce gratuite.</span> Encore '+(5-n)+' pièce'+((5-n)>1?'s':'')+' → une 2ᵉ offerte (−'+prices[1]+' €)';
    return '<span class="ok">Maximum atteint — 2 pièces offertes</span>';
  }
  function gameHTML(n){
    var pct=Math.min(n/5,1)*100;
    return '<div class="game"><div class="gtrack"><div class="gfill" style="width:'+pct+'%"></div>'
      +'<div class="gnode'+(n>=3?' reached':'')+'" data-need="3" style="left:60%"><span class="chk"></span><span class="lab">1 gratuite</span></div>'
      +'<div class="gnode last'+(n>=5?' reached':'')+'" data-need="5" style="left:100%"><span class="chk"></span><span class="lab">2 offertes</span></div>'
      +'</div></div>';
  }

  // ---- filtres ----
  var selType='best', selColor='all';
  var TYPE_TABS=[{k:'best',l:'Best-sellers'},{k:'Ensembles',l:'Ensembles'},{k:'Bodys',l:'Bodys'},{k:'Nuisettes',l:'Nuisettes'},{k:'Pyjamas',l:'Pyjamas'},{k:'Harnais',l:'Harnais'},{k:'all',l:'Tout'}];
  var SW={'Noir':'#1a1614','Rouge':'#b3122a','Bordeaux':'#7a1020','Blanc':'#efe9e2','Crème':'#efe7da','Bleu':'#2f4b6e','Bleu turquoise':'#43a2b4','Bleu marine':'#0a2b58','Vert':'#2f5d4a','Nude':'#e3c6aa','Rosé':'#e1bea6','Rose':'#e8a6b8','Gris':'#8a8288','Marron':'#5b3a29','Moka':'#4b3621'};
  var CORDER=['Noir','Rouge','Bordeaux','Bleu','Bleu turquoise','Bleu marine','Blanc','Vert','Nude','Rosé','Rose','Gris','Moka'];
  var SWMAP={}; PRODUCTS.forEach(function(p){ var c=p.colors[0]; if(c && p.swatch && !SWMAP[c]) SWMAP[c]=p.swatch; });
  var presentC=[]; PRODUCTS.forEach(function(p){p.colors.forEach(function(c){if(presentC.indexOf(c)<0)presentC.push(c);});});
  presentC.sort(function(a,b){var ia=CORDER.indexOf(a),ib=CORDER.indexOf(b);ia=ia<0?99:ia;ib=ib<0?99:ib;return ia-ib;});
  var COLOR_TABS=[{k:'all',l:'Toutes couleurs'}].concat(presentC.map(function(c){return {k:c,l:c,sw:SWMAP[c]||SW[c]||'#cbb8a8'};}));
  var filtType=$('irs-filtType'), filtColor=$('irs-filtColor');
  function present(key,getter){ return PRODUCTS.some(function(p){ return getter(p,key); }); }
  function renderFilters(){
    filtType.innerHTML=TYPE_TABS.filter(function(f){return f.k==='best'||f.k==='all'||present(f.k,function(p,k){return p.cat===k;});})
      .map(function(f){return '<button class="filt'+(f.k===selType?' on':'')+'" data-k="'+f.k+'">'+f.l+'</button>';}).join('');
    filtColor.innerHTML=COLOR_TABS.filter(function(f){return f.k==='all'||present(f.k,function(p,k){return p.colors.indexOf(k)>=0;});})
      .map(function(f){return '<button class="filt'+(f.k===selColor?' on':'')+'" data-k="'+f.k+'">'+(f.sw?'<span class="sw" style="background:'+f.sw+'"></span>':'')+f.l+'</button>';}).join('');
  }
  function applyFilter(){
    Array.prototype.forEach.call(grid.querySelectorAll('.card'),function(card){
      var p=byId(card.dataset.id);
      var okT = selType==='all' || (selType==='best'? p.best : p.cat===selType);
      var okC = selColor==='all' || p.colors.indexOf(selColor)>=0;
      card.style.display=(okT&&okC)?'':'none';
    });
  }
  filtType.addEventListener('click',function(e){var b=e.target.closest('.filt');if(!b)return;selType=b.dataset.k;renderFilters();applyFilter();});
  filtColor.addEventListener('click',function(e){var b=e.target.closest('.filt');if(!b)return;selColor=b.dataset.k;renderFilters();applyFilter();});

  // ---- récap ----
  function recapHTML(){
    var c=compute(), n=c.n, msg=progMsg();
    var items = n? ('<ul class="items">'+cart.map(function(it,i){var f=c.freeSet[i];return '<li>'
      +'<img class="sw" src="'+it.img+'" alt="">'
      +'<div class="meta"><div class="n">'+it.name+(f?'<span class="free-tag">Gratuit</span>':'')+'</div><div class="s">'+it.sizeLabel+'</div></div>'
      +'<div class="pr '+(f?'free':'')+'">'+(f?('<s>'+it.price+' €</s>0 €'):(it.price+' €'))+'</div>'
      +'<button class="rm" data-uid="'+it.uid+'">×</button></li>';}).join('')+'</ul>') : '<div class="empty">Votre sélection est vide.</div>';
    var pct = c.sub? Math.round(c.save/c.sub*100):0;
    var totals = n? ('<div class="totals">'
      +'<div class="row"><span>Sous-total</span><span>'+c.sub+' €</span></div>'
      +'<div class="row save"><span>Pièces offertes</span><span>−'+c.save+' €</span></div>'
      +'<div class="row grand"><span>Total</span><span>'+(c.save?('<s>'+c.sub+' €</s>'):'')+c.total+' €</span></div></div>') : '';
    var saveBadge = c.save? ('<div class="save-badge"><span>Vous économisez'+(pct?(' · −'+pct+'%'):'')+'</span><b>'+c.save+' €</b></div>') : '';
    var testi = n? '<div class="testi"><div class="st">★★★★★</div><q>4,8/5 sur 12 000 avis — 52 000+ clientes comblées.</q><span class="auth">Note moyenne vérifiée · Iris Lingerie</span></div>' : '';
    var cta = n? ('<button class="btn dark block cta-add"'+(n<3?' disabled style="opacity:.4;cursor:not-allowed"':'')+'>'+(n>=3?('Ajouter au panier · '+c.total+' €'):('Plus que '+(3-n)+' pièce'+((3-n)>1?'s':'')))+'</button>'
      +'<div class="micro"><span><b>Expédié sous 24h</b> · Échange de taille gratuit</span><span>Livraison offerte · retours 30 jours</span></div>') : '';
    return '<h3>Votre sélection</h3>'+gameHTML(n)+'<div class="prog-msg">'+msg+'</div>'+items+totals+saveBadge+testi+cta;
  }
  function render(){
    var c=compute(), n=c.n;
    $('irs-recapDesktop').innerHTML=recapHTML();
    $('irs-recapMobile').innerHTML=recapHTML();
    $('irs-barMsg').innerHTML=progMsg();
    $('irs-barGame').innerHTML=gameHTML(n);
    $('irs-barTotal').textContent=c.total+' €';
    $('irs-barSave').textContent = c.save? ('vous économisez '+c.save+' €') : '';
    $('irs-openDrawer').textContent = n? ('Ma sélection · '+n) : 'Ma sélection';
    var tw=$('irs-barThumbs');
    tw.style.display = n? 'flex':'none';
    tw.innerHTML = n? (cart.slice(0,6).map(function(it,i){return '<img class="bthumb'+(c.freeSet[i]?' free':'')+'" src="'+it.img+'" alt="">';}).join('') + (n>6?('<span class="bmore">+'+(n-6)+'</span>'):'')) : '';
    var counts={}; cart.forEach(function(it){counts[it.id]=(counts[it.id]||0)+1;});
    Array.prototype.forEach.call(grid.querySelectorAll('.card'),function(card){
      var q=counts[card.dataset.id]||0;
      card.classList.toggle('in',q>0);
      card.querySelector('.qty').textContent=q;
      card.querySelector('.addbtn').textContent=q>0?'✓':'+';
    });
  }

  // remove item + ajout panier réel
  document.body.addEventListener('click',function(e){
    var rm=e.target.closest('.rm');
    if(rm){ cart=cart.filter(function(x){return ''+x.uid!==''+rm.dataset.uid;}); render(); return; }
    var add=e.target.closest('.cta-add');
    if(add && !add.disabled){
      var items=cart.map(function(it){return {id:it.vid,quantity:1};}).filter(function(x){return x.id;});
      if(!items.length) return;
      add.textContent='Ajout en cours…'; add.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){return r.json();})
        .then(function(){ window.location.href='/cart'; })
        .catch(function(){ alert('Erreur lors de l’ajout au panier. Réessayez.'); add.disabled=false; });
    }
  });

  function show(id){ $(id).classList.add('show'); $('irs-overlay').classList.add('show'); document.body.style.overflow='hidden'; }
  function hide(id){ $(id).classList.remove('show'); $('irs-overlay').classList.remove('show'); document.body.style.overflow=''; }
  $('irs-overlay').addEventListener('click',function(){hide('irs-sheet');hide('irs-drawer');});
  $('irs-closeSheet').addEventListener('click',function(){hide('irs-sheet');});
  $('irs-closeDrawer').addEventListener('click',function(){hide('irs-drawer');});
  $('irs-openDrawer').addEventListener('click',function(){show('irs-drawer');});

  // ---- avis (réels) ----
  var REVIEWS=[
    {q:"Les coupes sont originales et raffinées.",b:"Les coupes sont originales et raffinées, chaque ensemble met ma silhouette en valeur. L'ensemble Elodie a quelque chose de spécial, élégant et mystérieux. Je recommande les yeux fermés.",a:"Camille M.",l:"Lyon"},
    {q:"Un niveau de service rare aujourd'hui.",b:"Première commande de 3 ensembles, petit souci sur un ensemble. Alice du SAV m'a répondu dans la soirée, et 48h après j'avais une solution. Un niveau de service rare aujourd'hui. Merci.",a:"Sophie D.",l:"Toulouse"},
    {q:"On sent la qualité au touché.",b:"Je commande rarement sur le net mais là, expérience au top. La nuisette taille parfaitement (j'ai suivi le conseil de prendre au-dessus). On sent la qualité au touché, les coutures sont propres.",a:"Émilie B.",l:"Nantes"},
    {q:"Aussi belle sur elle que sur le site.",b:"J'ai offert le body Salomé à ma femme qui n'a pas la taille mannequin : il met vraiment ses formes en valeur. La coupe est sublime, les réglages parfaits.",a:"Thomas R.",l:"Bordeaux"},
    {q:"Enfin une lingerie sexy qui ne m'infantilise pas.",b:"Taille 32, 85A, 156cm pour 40kg : enfin une lingerie sexy qui ne m'infantilise pas ! Le 34 convient très bien grâce aux réglages. Mes petites formes sont enfin mises en valeur.",a:"Léa P.",l:"Nice"},
    {q:"Choisir la taille de chaque article : un vrai plus.",b:"Plusieurs commandes pour ma femme : Elodie, Fanny, Eden, Body Shadow, Harnais Julietta, elle est fan ! Pouvoir choisir la taille de chaque article de l'ensemble, c'est un vrai plus.",a:"Nicolas V.",l:"Lille"},
    {q:"J'ai même fait du vélo avec, aucune gêne.",b:"Confort incroyable, j'ai même fait du vélo électrique avec sans aucune gêne. Les réglages coulissants permettent d'adapter à chaque morphologie.",a:"Claire H.",l:"Rennes"},
    {q:"Les réglages au dos changent tout.",b:"Bonnet F au petit dos (80), j'étais sceptique sur le fit. Les réglages au dos sont géniaux, j'ai tout pris en S. Les dentelles sont magnifiques. Foncez les filles !",a:"Marion G.",l:"Marseille"},
    {q:"Sublime toutes les silhouettes.",b:"Lingerie magnifique qui sublime toutes les silhouettes, même les poitrines les plus menues. Chaque élément est réglable. Un vrai coup de cœur !",a:"Inès C.",l:"Strasbourg"},
    {q:"Un service client d'exception.",b:"Contactée pour des questions de tailles, un échange, puis un retour partiel : à chaque fois réactifs et arrangeants. Ils ont même renvoyé les nouvelles tailles sans attendre le retour.",a:"Hélène F.",l:"Montpellier"}
  ];
  function renderReviews(){
    var t=$('irs-rvTrack'), d=$('irs-rvDots'); if(!t)return;
    t.innerHTML=REVIEWS.map(function(r){return '<article class="rv-card"><div class="rv-stars">★★★★★</div><p class="rv-q">'+r.q+'</p><p class="rv-b">'+r.b+'</p><div class="rv-auth">'+r.a+' · '+r.l+' · achat vérifié</div></article>';}).join('');
    d.innerHTML=REVIEWS.map(function(_,k){return '<span class="rv-dot'+(k===0?' on':'')+'"></span>';}).join('');
    var dots=Array.prototype.slice.call(d.children);
    t.addEventListener('scroll',function(){ var card=t.querySelector('.rv-card'); if(!card)return; var i=Math.round(t.scrollLeft/(card.offsetWidth+14)); dots.forEach(function(x,k){x.classList.toggle('on',k===i);}); },{passive:true});
  }

  renderFilters();
  applyFilter();
  renderReviews();
  render();
})();
